import {Layout} from '../../src/Layout';
export default Layout;

import docs from 'docs:react-aria-components';
import {Link as VanillaLink} from 'vanilla-starter/Link';
import {Link as TailwindLink} from 'tailwind-starter/Link';
import tailwindDocs from 'docs:tailwind-starter/Link';
import '../../tailwind/tailwind.css';

export const tags = ['anchor', 'hyperlink', 'href'];
export const relatedPages = [{'title': 'useLink', 'url': './Link/useLink'}];
export const description = 'Allows a user to navigate to another page or resource within a web page or application.';

# Link

<PageDescription>{docs.exports.Link.description}</PageDescription>

<ExampleSwitcher>
  <VisualExample
    component={VanillaLink}
    docs={docs.exports.Link}
    links={docs.links}
    props={['children', 'isDisabled']}
    initialProps={{children: 'The missing link', href: 'https://www.imdb.com/title/tt6348138/', target: '_blank'}}
    type="vanilla"
    files={["starters/docs/src/Link.tsx", "starters/docs/src/Link.css"]} />
  <VisualExample
    component={TailwindLink}
    docs={tailwindDocs.exports.Link}
    links={tailwindDocs.links}
    props={['children', 'variant', 'isDisabled']}
    initialProps={{children: 'The missing link', href: 'https://www.imdb.com/title/tt6348138/', target: '_blank'}}
    type="tailwind"
    files={["starters/tailwind/src/Link.tsx"]} />
</ExampleSwitcher>

## Client side routing

By default, links with an `href` are handled by the browser as regular page navigations. To integrate with a client side router, use the `render` prop to delegate to your router's link component. This supports features like prefetching on hover and avoids full page reloads.

<ExampleSwitcher type="framework" examples={['Next.js', 'React Router']}>
  ```tsx
  import {Link} from 'react-aria-components/Link';
  import NextLink from 'next/link';

  <Link href="/about" render={props => <NextLink {...props} />}>
    About
  </Link>
  ```

  ```tsx
  import {Link} from 'react-aria-components/Link';
  import {Link as RouterLink} from 'react-router';

  <Link href="/about" render={props => <RouterLink {...props} to={props.href} />}>
    About
  </Link>
  ```
</ExampleSwitcher>

See the [customization](customization#dom-elements) guide for more details on the `render` prop.

## Events

Links without an `href` will be rendered as a `<span role="link">` instead of an `<a>`. Use the `onPress` event to handle user interaction.

```tsx render
"use client";
import {Link} from 'vanilla-starter/Link';

<Link onPress={() => alert('Pressed link')}>Link</Link>
```

## API

<PropTable component={docs.exports.Link} links={docs.links} />
